export default "__VITE_ASSET__U3EaVRmi__"